var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "link-instructions-component" },
    [
      !_vm.disableTitle
        ? _c(
            "div",
            [
              _c("Center", { staticClass: "welcome-banner mb-3" }, [
                _c("h1", { staticClass: "ma-0" }, [
                  _vm._v("\n        Connect your App in 2 Easy Steps\n      ")
                ])
              ]),
              _vm._v(" "),
              _vm._m(0)
            ],
            1
          )
        : _c("div", [
            _c("h2", { staticClass: "mb-3" }, [
              _vm._v("Connect extra servers:")
            ])
          ]),
      _vm._v(" "),
      _c("VerticalTabs", { attrs: { tabs: _vm.linkInstructions } }, [
        _c(
          "div",
          { attrs: { slot: "Server" }, slot: "Server" },
          [_c("ProviderInstructions", { attrs: { provider: "baremetal" } })],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { attrs: { slot: "Docker" }, slot: "Docker" },
          [_c("ProviderInstructions", { attrs: { provider: "docker" } })],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { attrs: { slot: "AWS" }, slot: "AWS" },
          [_c("ProviderInstructions", { attrs: { provider: "ebs" } })],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "mt-1",
            attrs: { slot: "after-tabs" },
            slot: "after-tabs"
          },
          [
            _c(
              "a",
              {
                attrs: {
                  target: "_blank",
                  href: "http://doc.pm2.io/en/plus/overview/"
                }
              },
              [
                _c("KmIcon", {
                  staticClass: "ml-2",
                  attrs: { size: 18, name: "km-icon-support" }
                }),
                _vm._v(" Documentation")
              ],
              1
            )
          ]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "expl" }, [
      _vm._v(
        "\n      Welcome to PM2.io, an advanced monitoring system for Node.js application and servers."
      ),
      _c("br"),
      _vm._v(" "),
      _c("b", [
        _vm._v(
          "You can now connect up to 4 servers or Node.js processes for free"
        )
      ]),
      _vm._v(". Try it out:\n    ")
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }